import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import ToolCard from '../components/ToolCard'
import { CATEGORIES, TOOLS, getToolsByCategory } from '../data/tools'
import './Home.css'

function Home() {
  return (
    <>
      <SEO
        title="WebToolz365 - Free Online Tools for Everyday Tasks"
        description="66+ free online tools: convert files, format text, calculate, compare data, currency rates, timezones, IP geolocation, and more. No signup, runs in your browser, mobile friendly."
        keywords="online tools website, free online tools, image converter online, pdf converter online, word counter tool, case converter tool, qr code generator free, password generator tool, webtoolz365"
        canonicalUrl="/"
        publishedTime="2024-01-01T00:00:00Z"
      />

      <div className="hero">
        <div className="container">
          <div className="hero-badge">Free. Fast. Privacy-first.</div>
          <h1>Useful online tools for everyone</h1>
          <p className="hero-subtitle">{TOOLS.length} tools in one place, so you can stop switching tabs.</p>
          <p className="hero-description">
            Convert, compare, format, and plan in seconds. Most tools run directly in your browser with no signup,
            no upload flow for core tasks, and clean mobile-friendly pages.
          </p>
          <div className="hero-stats">
            <div className="stat-item"><div className="stat-value">{TOOLS.length}</div><div className="stat-label">Free Tools</div></div>
            <div className="stat-item"><div className="stat-value">100%</div><div className="stat-label">No Signup</div></div>
            <div className="stat-item"><div className="stat-value">0</div><div className="stat-label">Backend for core tools</div></div>
            <div className="stat-item"><div className="stat-value">24/7</div><div className="stat-label">Available</div></div>
          </div>
        </div>
      </div>

      <div className="container">
        <section className="category-hub-strip" aria-labelledby="category-hub-strip-title">
          <h2 id="category-hub-strip-title" className="category-hub-strip-title">Browse by category</h2>
          <p className="category-hub-strip-desc">
            Choose a category below and open the exact tool you need. Each tool has a clear page, practical copy,
            and one-click actions built for everyday use.
          </p>
          <nav className="category-hub-strip-links" aria-label="Category hubs">
            {CATEGORIES.map((c) => (
              <Link key={c.id} to={`/${c.route}`}>
                {c.navTitle}
              </Link>
            ))}
            <Link to="/blog">Blog</Link>
          </nav>
        </section>

        {CATEGORIES.map((c) => (
          <section key={c.id} id={c.id} className="tools-section">
            <h2 className="section-title">{c.homeHeading}</h2>
            <div className="tools-grid">
              {getToolsByCategory(c.id).map((tool) => (
                <ToolCard key={tool.slug} {...tool} />
              ))}
            </div>
          </section>
        ))}

        <section className="features">
          <h2 className="section-title">Why people bookmark WebToolz365</h2>
          <div className="features-grid">
            <div className="feature-card"><div className="feature-icon">⊗</div><h3>Private by default</h3><p>Core tools run locally in your browser, so your data stays with you.</p></div>
            <div className="feature-card"><div className="feature-icon">⚡</div><h3>Fast workflow</h3><p>No accounts or setup. Open, paste, convert, copy, done.</p></div>
            <div className="feature-card"><div className="feature-icon">∞</div><h3>Always free</h3><p>No trial locks or hidden upgrades for basic utility tasks.</p></div>
            <div className="feature-card"><div className="feature-icon">◉</div><h3>Works worldwide</h3><p>Mobile and desktop friendly tools for students, teams, and creators.</p></div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Home
